import loadable from '@loadable/component';

export const OrgDashboardListCreditsPageLoadable = loadable(
  () => import('./OrgDashboardListCreditsPage'),
  { resolveComponent: (module) => module.OrgDashboardListCreditsPage },
);
